module.exports = __webpack_public_path__ + "static/img/logo-3.5f98487.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-3.png
// module id = +hM+
// module chunks = 0